module.exports = __webpack_public_path__ + "media/images/workplace/social-ico/facebook-ico-de48d8b4d6ea5dbbf8e436b2a3d911e0.svg";